import { Typography } from '@mui/material';
import React from 'react';
import {
    formatHypothesisText,
    formatOperationType,
} from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/helpers/dataHelpers';
import { FreeHypothesis } from 'routes/HumanResourcesModule/Simulation/SimulationSynthesis/GVT/PayConstants/components/FreeHypothesis/helpers/types';
import { SimulationDateString } from 'routes/HumanResourcesModule/Simulation/helpers/types';
import Flex from 'ui/Flex/Flex';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';

const FreeHypotheses = ({
    freeHypotheses,
}: {
    freeHypotheses: FreeHypothesis[];
}): React.ReactElement => {
    const { t } = useTranslation();
    return (
        <Flex display="flex" flexDirection="column" alignItems="flex-start">
            {freeHypotheses.map((hypothesis) => {
                const { value, filters, operation, valueType } = hypothesis;
                const {
                    category,
                    filiere,
                    cadreEmploi,
                    jobLabel,
                    date,
                    greaterThan,
                    lowerThan,
                } = filters;

                return (
                    <Flex
                        flexDirection="row"
                        justifyContent="space-between"
                        key={hypothesis.id}
                    >
                        <Typography variant="body1SemiBold">
                            {t(
                                `humanResources.simulation.freeHypothesis.hypothesisType_one`,
                                {
                                    type: 'IFSE',
                                },
                            )}
                        </Typography>

                        <Typography
                            sx={() => ({
                                maxWidth: '85%',
                                textAlign: 'right',
                            })}
                        >
                            {parse(
                                t(
                                    `humanResources.simulation.freeHypothesis.duplicationText`,
                                    {
                                        operation: formatOperationType(
                                            operation,
                                            value,
                                            valueType,
                                        ),
                                        data: formatHypothesisText(
                                            category,
                                            filiere,
                                            cadreEmploi,
                                            jobLabel,
                                            date as SimulationDateString,
                                            greaterThan,
                                            lowerThan,
                                        ),
                                    },
                                ),
                            )}
                        </Typography>
                    </Flex>
                );
            })}
        </Flex>
    );
};

export default FreeHypotheses;
